import * as types from '../constants/types';
import * as roles from '../utilities/roles';
import { AllHighLvlLocationsArr } from '../utilities/locations';

export const setTabIndex = (index) => {
  return {
    type: types.SET_SELECTED_TAB_INDEX,
    index,
  };
};

export const requireUserListThrottle = (force) => {
  const throttle = typeof force === 'boolean' ? force : true;
  return {
    type: types.THROTTLE_USER_LIST,
    throttle,
  };
};

export function checkUserListThrottle() {
  return async (dispatch, getState) => {
    const state = getState();
    const user = state.login.user;
    const isPmoOrApmOrCsr = user.roles.some(
      (role) =>
        role.role_type === roles.SUPER_USER ||
        role.role_type === roles.PMO ||
        role.role_type === roles.ATR ||
        role.role_type === roles.CSR1
    );

    const isHighLvlUser = user.roles.some((role) =>
      AllHighLvlLocationsArr.includes(role.location_type !== '' ? role.location_type : role.location.location_type)
    );
    if (isPmoOrApmOrCsr || isHighLvlUser) {
      dispatch(requireUserListThrottle());
    }
  };
}

export const searchFieldChanged = (field) => ({
  type: types.USER_SEARCH_FIELD_CHANGED,
  field,
});

export const searchValueChanged = (value) => ({
  type: types.USER_SEARCH_VALUE_CHANGED,
  value,
});

export const filterChanged = (value) => ({
  type: types.USER_SEARCH_FILTER_CHANGED,
  value,
});
